import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vnygmvx76j: FaireBrandEntity = {
  token: "b_vnygmvx76j",
  type: "brand",
  name: "Kiyo Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4c061bd96cfcd0d0f86873ca7c2f91aa29ea02e16537f70239133ac8281a594.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d7247bdc9bb4d09543b1fd88863f60c170abfb81416a7926f0b6371b45fe73c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f4c061bd96cfcd0d0f86873ca7c2f91aa29ea02e16537f70239133ac8281a594.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d7247bdc9bb4d09543b1fd88863f60c170abfb81416a7926f0b6371b45fe73c.jpeg",
  location: "Victoria, BC, CAN",
  minimumOrderDollars: 0,
  rating: 4.6,
  reviewCount: 58,
  isTopShop: true,
  isInsider: false,
  description:
    "Kiyo Home was founded on the belief that your home should be as unique as you are—a place that inspires and nurtures. Rooted in a love for nature and timeless design, we create decor and lighting that bring warmth and tranquility to your space. Each piece is thoughtfully curated to celebrate natural textures and neutral tones, blending style and comfort effortlessly.\n\nBut it’s not just about beautiful products; it’s about connection. Every purchase supports our commitment to sustainability, including carbon-neutral shipping and contributions to global conservation efforts. With Kiyo Home, you’re not only creating a home you love but helping make a meaningful impact on our planet.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.000Z",
    importedBy: "entity-db-cli",
  },
};
